<template>
  <div class="topBar">
    <div class="topBar_left">
      <div class="openMenus">
        <el-button
          :icon="Expand"
          size="default"
          circle
          class="collapse-btn"
          @click="this.isCollapse = !this.isCollapse"
        />
      </div>
      <div class="admin-brand">
        <span class="system-title">系统管理中心</span>
        <span class="admin-badge">ADMIN</span>
      </div>
    </div>
  </div>
  <div class="panel">
    <div class="panel_left">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        :collapse="isCollapse"
        @open="handleOpen"
        @close="handleClose"
      >
        <router-link :to="'/admin/aabb/audit'" v-if="status == 2 || status == 1"
          ><el-menu-item index="1">
            <el-icon><setting /></el-icon>
            <template #title>审核管理</template>
          </el-menu-item></router-link
        >
        <router-link :to="'/admin/aabb/personnel'" v-if="status == 1"
          ><el-menu-item index="2">
            <el-icon><document /></el-icon>
            <template #title> 人员管理 </template>
          </el-menu-item></router-link
        >
        <router-link :to="'/admin/aabb/apply'" v-if="status == 2 || status == 1"
          ><el-menu-item index="3">
            <el-icon><SwitchFilled /></el-icon>
            <template #title> 创作管理 </template>
          </el-menu-item></router-link
        >
        <router-link
          :to="'/admin/aabb/feedback'"
          v-if="status == 2 || status == 1"
          ><el-menu-item index="4">
            <el-icon><Warning /></el-icon>
            <template #title> 反馈管理 </template>
          </el-menu-item></router-link
        >
        <router-link
          :to="'/admin/aabb/advertise'"
          v-if="status == 2 || status == 1"
          ><el-menu-item index="5">
            <el-icon><Money /></el-icon>
            <template #title> 广告管理 </template>
          </el-menu-item></router-link
        >

        <router-link :to="'/admin/aabb/ticket'" v-if="status == 1"
          ><el-menu-item index="6">
            <el-icon><Money /></el-icon>
            <template #title> 优惠卷管理 </template>
          </el-menu-item></router-link
        >
      </el-menu>
    </div>
    <div class="panel_right">
      <el-scrollbar>
        <router-view class="rv" />
      </el-scrollbar>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
} from "vue";
import {
  Document,
  Menu as IconMenu,
  Location,
  Setting,
  Check,
  SwitchFilled,
  Expand,
  Warning,
  Money,
} from "@element-plus/icons-vue";

export default defineComponent({
  name: "App",
  data(): any {
    return {
      isCollapse: false,
    };
  },
  components: {
    Money,
    Warning,
    Document,
    Setting,
    SwitchFilled,
  },
  computed: {
    Expand() {
      return Expand;
    },
    Check() {
      return Check;
    },
    status(): number {
      return this.$store.state.user.status;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    handleOpen: (key: string, keyPath: string[]) => {},
    handleClose: (key: string, keyPath: string[]) => {},
  },
});
</script>

<style lang="less" scoped>
// 管理员后台核心色调规范（黑曜石暗黑风 + 科技高亮）
@topbar-height: 60px;
@admin-sidebar-bg: #0f172a; // 沉稳暗黑灰蓝底色
@admin-sidebar-hover: #1e293b; // 悬停深灰蓝
@admin-active-bg: #1e1b4b; // 激活态深紫底
@admin-primary: #6366f1; // 核心高亮靛青蓝
@admin-gold: #f59e0b; // 管理员徽标金色
@border-dark: #1e293b;
@border-light: #e2e8f0;
@bg-page: #f1f5f9;

// 消除默认 router-link 影响
a {
  text-decoration: none;
  color: inherit;
  display: block;
}

// 顶栏：融合科技白与硬朗分割线
.topBar {
  width: 100%;
  height: @topbar-height;
  border-bottom: 1px solid @border-light;
  box-sizing: border-box;
  padding: 0 24px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;

  &_left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .collapse-btn {
    background: #f8fafc !important;
    border: 1px solid @border-light !important;
    color: #475569 !important;
    transition: all 0.2s ease;

    &:hover {
      background: #e2e8f0 !important;
      color: #0f172a !important;
      transform: scale(1.05);
    }
  }

  // 管理员标识排版
  .admin-brand {
    display: flex;
    align-items: center;
    gap: 8px;

    .system-title {
      font-size: 15px;
      font-weight: 700;
      color: #0f172a;
      letter-spacing: 0.5px;
    }

    .admin-badge {
      font-size: 10px;
      font-weight: 800;
      color: #ffffff;
      background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
      padding: 2px 7px;
      border-radius: 4px;
      letter-spacing: 1px;
      box-shadow: 0 2px 6px rgba(79, 70, 229, 0.35);
    }
  }
}

// 主体框架
.panel {
  display: flex;
  width: 100%;
  height: calc(100vh - @topbar-height);
  margin-top: @topbar-height;
  overflow: hidden;
  background-color: @bg-page;

  // 深色管理侧边栏
  &_left {
    height: 100%;
    background: @admin-sidebar-bg;
    border-right: 1px solid @border-dark;
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.08);
    transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 10;
  }

  &_right {
    flex: 1;
    height: 100%;
    overflow: hidden;

    :deep(.el-scrollbar__wrap) {
      overflow-x: hidden;
    }

    .rv {
      padding: 24px;
      box-sizing: border-box;
      min-height: 100%;
    }
  }
}

// 管理侧边菜单定制
.el-menu {
  height: 100%;
  border-right: none !important;
  background: transparent !important;

  &:not(.el-menu--collapse) {
    width: 230px;
  }

  .el-menu-item {
    height: 48px;
    line-height: 48px;
    margin: 6px 14px;
    border-radius: 8px;
    color: #94a3b8;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.25s ease;
    position: relative;

    .el-icon {
      font-size: 18px;
      margin-right: 12px;
      color: #64748b;
      transition: color 0.2s;
    }

    &:hover {
      background-color: @admin-sidebar-hover !important;
      color: #f8fafc !important;

      .el-icon {
        color: #f8fafc;
      }
    }

    // 管理员选中态：暗黑紫调高亮 + 渐变边条
    &.is-active {
      background: @admin-active-bg !important;
      color: #ffffff !important;
      font-weight: 600;

      .el-icon {
        color: @admin-primary;
      }

      &::after {
        content: "";
        position: absolute;
        right: -6px;
        top: 25%;
        height: 50%;
        width: 4px;
        background: linear-gradient(to bottom, #818cf8, #4f46e5);
        border-radius: 4px;
        box-shadow: 0 0 10px rgba(99, 102, 241, 0.6);
      }
    }
  }
}
@media screen and (max-width: 700px) {
  .topBar {
    .changeBar {
      display: block;
    }
  }
}
</style>
